import React from "react";

export const TrophyIcon = () => {
  return (
    <svg
      width="71"
      height="71"
      viewBox="0 0 71 71"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M51.0923 1.05814H18.6194H15.1543C15.1543 1.05814 15.1544 34.8746 29.2224 42.7015C30.8806 43.6239 31.8878 45.3938 31.8878 47.2914H34.3588H39.1115C39.1115 45.3938 40.1187 43.6241 41.7769 42.7015C43.3013 41.8534 44.6603 40.6998 45.8721 39.3174C52.9994 31.1879 55.0331 15.1369 55.6133 6.63926C55.8448 3.24707 55.8451 1.05786 55.8451 1.05786H51.0923V1.05814Z"
          fill="#FECE00"
        />
        <path
          d="M1.05716 13.5605C1.20845 0.666306 15.3861 6.63917 15.3861 6.63917C15.475 7.93949 15.598 9.4169 15.7679 11.0154C12.0377 9.67233 4.07036 7.69474 5.18902 15.8377C6.32419 24.1015 9.9284 29.8147 14.7267 32.8957C17.3984 34.6112 20.3508 34.8538 22.0562 34.8196C22.9573 36.4819 23.9754 38.0035 25.1272 39.3173V39.3174C25.1272 39.3174 19.0979 40.4409 13.0912 36.8263C7.49777 33.4602 0.908368 26.2333 1.05716 13.5605Z"
          fill="#EEBF00"
        />
        <path
          d="M39.1121 52.1294H31.8887V58.5346H39.1121V52.1294Z"
          fill="#FECE00"
        />
        <path
          d="M39.1136 52.1294H31.7695V54.6407H39.1136V52.1294Z"
          fill="#DDB201"
        />
        <path
          d="M50.4481 63.1538H20.5547V69.9426H50.4481V63.1538Z"
          fill="#3E3D43"
        />
        <path
          d="M50.4481 67.3279H20.5547V69.9411H50.4481V67.3279Z"
          fill="#444444"
        />
        <path
          d="M44.8183 58.5347H26.1836V63.1524H44.8183V58.5347Z"
          fill="#77767E"
        />
        <path
          d="M44.8183 60.8435H26.1836V63.1525H44.8183V60.8435Z"
          fill="#3E3D43"
        />
        <path
          d="M39.2322 52.1295H31.7687C30.4326 52.1295 29.3496 51.0465 29.3496 49.7104C29.3496 48.3743 30.4326 47.2913 31.7687 47.2913H39.2322C40.5683 47.2913 41.6513 48.3743 41.6513 49.7104C41.6513 51.0465 40.5683 52.1295 39.2322 52.1295Z"
          fill="#CBA400"
        />
        <path
          d="M51.093 1.05811C51.093 1.05811 51.0929 3.24731 50.8612 6.6395C50.281 15.1372 48.2475 31.188 41.12 39.3176C39.908 40.7 38.5492 41.8536 37.0248 42.7017C35.3665 43.6242 34.3594 45.3941 34.3594 47.2916H39.1121C39.1121 45.3941 40.1192 43.6243 41.7775 42.7017C43.3019 41.8536 44.6609 40.7 45.8727 39.3176C53 31.1881 55.0336 15.1372 55.6138 6.6395C55.8454 3.24731 55.8457 1.05811 55.8457 1.05811H51.093Z"
          fill="#DDB201"
        />
        <path
          d="M32.6875 42.7015C18.6196 34.8746 18.6194 1.05811 18.6194 1.05811H15.1543C15.1543 1.05811 15.1544 34.8746 29.2224 42.7015C30.8806 43.6239 31.8878 45.3938 31.8878 47.2914H34.3588C34.3588 46.5041 34.5345 45.7399 34.8558 45.0481C34.4027 44.0722 33.6577 43.2413 32.6875 42.7015Z"
          fill="#FEDA44"
        />
        <path
          d="M69.9431 13.5605C69.7918 0.666306 55.6142 6.63917 55.6142 6.63917C55.5253 7.93949 55.4023 9.4169 55.2324 11.0154C58.9625 9.67219 66.9299 7.6946 65.8113 15.8375C64.6761 24.1014 61.0719 29.8145 56.2736 32.8955C53.6019 34.611 50.6495 34.8537 48.9441 34.8195C48.043 36.4817 47.0249 38.0034 45.873 39.3171V39.3173C45.873 39.3173 51.9023 40.4408 57.909 36.8262C63.5026 33.4602 70.0919 26.2333 69.9431 13.5605Z"
          fill="#EEBF00"
        />
        <path
          d="M12.9472 10.1779C13.9933 10.4172 14.9762 10.7303 15.768 11.0155C15.5981 9.41699 15.4751 7.93944 15.3863 6.63926C15.3863 6.63926 13.9919 6.05281 12.0742 5.64429C12.4192 7.14582 12.7462 8.65166 12.9472 10.1779Z"
          fill="#CBA400"
        />
        <path
          d="M22.0561 34.8196C21.1954 34.8369 20.0166 34.783 18.7168 34.5054C18.844 34.8554 18.9722 35.2058 19.1067 35.5544C19.7247 36.8764 20.481 38.1567 21.2507 39.4181C23.5697 39.607 25.127 39.3175 25.127 39.3175V39.3174C23.9754 38.0035 22.9572 36.4819 22.0561 34.8196Z"
          fill="#CBA400"
        />
        <path
          d="M58.0533 10.1779C57.0071 10.4172 56.0242 10.7303 55.2324 11.0155C55.4023 9.41699 55.5253 7.93944 55.6142 6.63926C55.6142 6.63926 57.0085 6.05281 58.9262 5.64429C58.5812 7.14582 58.2544 8.65166 58.0533 10.1779Z"
          fill="#CBA400"
        />
        <path
          d="M48.9439 34.8196C49.8047 34.8369 50.9835 34.783 52.2833 34.5054C52.1561 34.8554 52.0278 35.2058 51.8933 35.5544C51.2754 36.8764 50.5191 38.1567 49.7493 39.4181C47.4303 39.607 45.873 39.3175 45.873 39.3175V39.3174C47.0246 38.0035 48.0427 36.4819 48.9439 34.8196Z"
          fill="#CBA400"
        />
        <path
          d="M40.1663 59.5891H30.834V51.0752H40.1663V59.5891ZM32.9428 57.4803H38.0577V53.184H32.9428V57.4803Z"
          fill="black"
        />
        <path
          d="M39.2321 53.184H31.7685C29.8532 53.184 28.2949 51.6257 28.2949 49.7104C28.2949 47.7951 29.8532 46.2368 31.7685 46.2368H39.2321C41.1474 46.2368 42.7057 47.7951 42.7057 49.7104C42.7057 51.6257 41.1474 53.184 39.2321 53.184ZM31.7685 48.3457C31.0159 48.3457 30.4037 48.958 30.4037 49.7105C30.4037 50.4631 31.0159 51.0753 31.7685 51.0753H39.2321C39.9847 51.0753 40.5969 50.4631 40.5969 49.7105C40.5969 48.958 39.9847 48.3457 39.2321 48.3457H31.7685Z"
          fill="black"
        />
        <path
          d="M45.8715 64.2072H25.1289V57.4805H45.8715V64.2072ZM27.2377 62.0984H43.7628V59.5892H27.2377V62.0984Z"
          fill="black"
        />
        <path
          d="M51.5008 70.9965H19.498V62.0984H51.5008V70.9965ZM21.6068 68.8877H49.3922V64.2072H21.6068V68.8877Z"
          fill="black"
        />
        <path
          d="M40.1675 48.3457H30.8352V47.2914C30.8352 45.7575 30.0213 44.3518 28.7116 43.6228C25.3039 41.7269 22.4181 38.2658 20.1345 33.3359C18.3474 29.4779 16.9153 24.7008 15.8782 19.138C14.1219 9.71872 14.1016 1.14354 14.1016 1.05798V0.00366211H56.9013L56.9012 1.05812C56.9012 1.14895 56.8983 3.32207 56.6668 6.71121C56.0614 15.5788 53.9572 31.6971 46.6666 40.0125C45.3312 41.5358 43.8591 42.7507 42.2913 43.623C40.9814 44.352 40.1677 45.7575 40.1677 47.2915L40.1675 48.3457ZM32.8569 46.2369H38.1461C38.4588 44.361 39.5951 42.7098 41.2661 41.7801C42.622 41.0258 43.9054 39.9633 45.0811 38.6222C51.9629 30.7728 53.9759 15.1698 54.563 6.56741C54.6957 4.6217 54.7519 3.06747 54.7753 2.1123H16.2292C16.3804 7.83542 17.7332 35.1017 29.7368 41.78C31.4078 42.7099 32.5443 44.361 32.8569 46.2369Z"
          fill="black"
        />
        <path
          d="M48.1909 40.537C48.1905 40.537 48.1906 40.537 48.1904 40.537C46.6795 40.5368 45.7202 40.3615 45.6801 40.3539L43.8594 40.015L45.0804 38.6223C46.129 37.4263 47.117 35.9777 48.0174 34.3171L48.3236 33.7525L48.9657 33.7655C49.0533 33.7671 49.1444 33.7681 49.2387 33.7681C50.9381 33.7681 53.4392 33.4629 55.704 32.0085C60.5285 28.9106 63.7471 23.1168 64.7668 15.6942C65.0117 13.9122 64.7952 12.6182 64.1237 11.8483C63.5395 11.1782 62.5382 10.8385 61.1474 10.8385C59.2374 10.8385 57.0709 11.4742 55.5899 12.0076L54.0064 12.5779L54.1842 10.9044C54.3367 9.46828 54.4639 8.00918 54.5625 6.56769L54.6066 5.91995L55.2049 5.66785C55.3469 5.60794 58.7212 4.20361 62.3141 4.20361C67.8429 4.20361 70.9268 7.5223 70.9976 13.5484C71.0672 19.4766 69.7153 24.7536 66.9794 29.2331C64.2932 33.6311 60.86 36.2813 58.4529 37.7297C54.5974 40.0497 50.7443 40.537 48.1909 40.537ZM47.9284 38.4261C48.0133 38.4275 48.1008 38.4282 48.1904 38.4282C48.1905 38.4282 48.1908 38.4282 48.1909 38.4282C50.4772 38.4282 53.9246 37.9934 57.3654 35.9229C60.8842 33.8053 69.051 27.3885 68.8891 13.5731C68.8315 8.68728 66.6809 6.31225 62.3141 6.31225C59.979 6.31225 57.6726 7.01615 56.6179 7.38751C56.5654 8.09404 56.5064 8.80335 56.4412 9.51071C57.8742 9.08971 59.563 8.72944 61.1473 8.72944C63.1744 8.72944 64.7106 9.31227 65.7131 10.462C66.8027 11.7118 67.1873 13.5687 66.856 15.9809C66.2881 20.1134 65.1017 23.766 63.3294 26.837C61.6375 29.7688 59.4552 32.1057 56.8435 33.7825C54.2925 35.4207 51.5333 35.8338 49.5652 35.8733C49.0451 36.7878 48.4985 37.6407 47.9284 38.4261Z"
          fill="black"
        />
        <path
          d="M22.8099 40.537C20.2561 40.537 16.4028 40.0498 12.5473 37.7297C10.1401 36.2812 6.7069 33.6311 4.02083 29.233C1.28498 24.7534 -0.0669271 19.4764 0.00254738 13.5482C0.0732699 7.5222 3.15705 4.20337 8.68602 4.20337C12.279 4.20337 15.6533 5.6077 15.7952 5.6676L16.3934 5.91971L16.4376 6.5673C16.5365 8.01282 16.6637 9.47178 16.8159 10.904L16.9937 12.5776L15.4102 12.0074C13.9292 11.4741 11.7626 10.8384 9.85267 10.8384C8.46193 10.8384 7.46045 11.178 6.87636 11.8481C6.20477 12.6182 5.98845 13.912 6.2332 15.694C7.25285 23.1165 10.4714 28.9105 15.2959 32.0083C17.5609 33.4627 20.0619 33.7679 21.7612 33.7679C21.8557 33.7679 21.9468 33.7669 22.0344 33.7652L22.6765 33.7522L22.9825 34.3169C23.8829 35.9777 24.8711 37.4263 25.9194 38.6219L26.1811 38.9202V39.317C26.1811 39.5914 26.0777 40.2452 25.1192 40.386C24.9644 40.4087 24.794 40.4298 24.6127 40.4484C24.0461 40.5073 23.4394 40.537 22.8099 40.537ZM8.68602 6.31215C4.31926 6.31215 2.1686 8.68718 2.11119 13.5727C1.94894 27.388 10.1159 33.805 13.6347 35.9226C17.0755 37.9932 20.5233 38.4278 22.8097 38.4278C22.8993 38.4278 22.9865 38.4271 23.0715 38.4257C22.5016 37.6403 21.9547 36.7875 21.4351 35.8733C19.4669 35.8338 16.7076 35.4207 14.1568 33.7826C11.5449 32.1055 9.36274 29.7686 7.67081 26.8371C5.89845 23.7661 4.71197 20.1136 4.14425 15.9809C3.81283 13.5686 4.19736 11.7117 5.28718 10.462C6.2895 9.31231 7.82571 8.72961 9.85295 8.72961C11.4371 8.72961 13.1257 9.08974 14.5589 9.51089C14.4939 8.80449 14.4348 8.09505 14.3822 7.38755C13.3281 7.01618 11.0214 6.31215 8.68602 6.31215Z"
          fill="black"
        />
        <path
          d="M55.7565 3.5498H15.1562V5.65858H55.7565V3.5498Z"
          fill="black"
        />
        <path
          d="M26.8348 37.7714C26.1616 37.0485 25.5155 36.2192 24.9141 35.3064L26.6751 34.1462C27.2119 34.9612 27.7847 35.6971 28.3779 36.3341L26.8348 37.7714Z"
          fill="white"
        />
        <path
          d="M24.104 33.9827C22.453 31.0766 21.1033 27.3555 20.0918 22.9228L22.1477 22.4539C23.1133 26.6857 24.3883 30.2139 25.9375 32.941L24.104 33.9827Z"
          fill="white"
        />
        <path
          d="M59.7421 48.0293L59.7383 42.3596L57.6295 42.3611L57.6334 48.0308L59.7421 48.0293Z"
          fill="black"
        />
        <path
          d="M61.5248 46.2477L61.5234 44.1389L55.8537 44.1426L55.8551 46.2514L61.5248 46.2477Z"
          fill="black"
        />
        <path
          d="M14.1322 53.5466H12.0234V58.6428H14.1322V53.5466Z"
          fill="black"
        />
        <path d="M15.6274 55.04H10.5312V57.1488H15.6274V55.04Z" fill="black" />
        <path
          d="M8.76268 39.9595H6.77344V42.0683H8.76268V39.9595Z"
          fill="black"
        />
        <path
          d="M21.5478 46.1985H19.5586V48.3073H21.5478V46.1985Z"
          fill="black"
        />
        <path
          d="M53.6103 52.5427H51.6211V54.6515H53.6103V52.5427Z"
          fill="black"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="71" height="71" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
